export default {
  setCookie(key = '', value = '', time = this.EXPIRES) {
    var exp = new Date(Date.now() + time)
    document.cookie = `${key}=${encodeURIComponent(value)};expires=${exp.toGMTString()};path=/;`
  },
  getCookie(key) {
    var arr, reg = new RegExp(`(${'^| '})${key}=([^;]*)(;|$)`)
    if (arr = document.cookie.match(reg)) {
      return decodeURIComponent(arr[2])
    } else {
      return null
    }
  },
  delCookie(key) {
    var value = this.getCookie(key)
    this.setCookie(key, value, -1)
  }
}



// WEBPACK FOOTER //
// ./src/utils/localStorageUtils.js